import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { ImportModule } from "../../import/import.module";

@TypeManagerDecorator("s25-ng-se-config-import-page")
@Component({
    selector: "s25-ng-se-config-import-page",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ImportModule],
    template: `
        <div class="c-padding--double se-config-page">
            <h2>Spreadsheet Import Tool</h2>
            <s25-ng-import />
        </div>
    `,
    styles: `
        :host {
            display: block;
        }

        h2 {
            margin-bottom: 1rem;
            font-size: 1.25rem;
            font-weight: 600;
        }
    `,
})
export class SeConfigImportPageComponent {}
